/** The Z mark exactly as the mockup draws it (240-unit square, four polygons). */
export function Logo({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 240 240" role="img" aria-label="Zoomo Rides logo" style={{ display: 'block' }}>
      <rect width="240" height="240" rx="52" fill="#0D0D0D" />
      <rect x="1.5" y="1.5" width="237" height="237" rx="50.5" fill="none" style={{ stroke: 'var(--logoEdge)' }} strokeWidth="3" />
      <g fill="#FFFFFF" transform="translate(61 51) scale(.35) translate(-165 -238)">
        <polygon points="165,268 420,268 323,350 165,350" />
        <polygon points="502,238 502,355 386,453 321,388" />
        <polygon points="276,421 340,483 165,632 165,516" />
        <polygon points="347,515 502,515 502,603 245,603" />
      </g>
    </svg>
  );
}
